import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { getEnv } from '@/lib/utils/common/getEnv';

export const redactSensitiveParams = (url: string): string => {
  return url
    .replace(/([?&])(?:jwt|token)=[^&]*&?/g, '$1')
    .replace(/[?&](?=#|$)/g, '')
    .replace(/\?&/g, '?');
};

export function initializeDatadogRUM() {
  const env = getEnv();
  if (!env.ddRumAppId || !env.ddRumClientToken) {
    return;
  }
  datadogRum.init({
    applicationId: env.ddRumAppId,
    clientToken: env.ddRumClientToken,
    site: 'datadoghq.com',
    service: 'nexus-frontend',
    env: env.ddEnv,

    // Use build-time injected commit hash
    version: __COMMIT_HASH__,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0, // We are not using session replay
    defaultPrivacyLevel: 'mask-user-input',

    plugins: [reactPlugin()],

    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackViewsManually: true,

    // Enable feature flag tracking
    enableExperimentalFeatures: ['feature_flags'],

    // Enable distributed tracing
    allowedTracingUrls: [
      {
        match: (url: string) => url.startsWith(env.apiBaseUrl),
        propagatorTypes: ['datadog', 'tracecontext'],
      },
    ],
    traceSampleRate: 100,

    beforeSend: (event) => {
      if (event.view?.url?.includes('jwt=') || event.view?.url?.includes('token=')) {
        event.view.url = redactSensitiveParams(event.view.url);
      }
      if (event.view?.referrer?.includes('jwt=') || event.view?.referrer?.includes('token=')) {
        event.view.referrer = redactSensitiveParams(event.view.referrer);
      }
      return true;
    },
  });
}
